<template>
  <div id="index" :style="{height:bodyHeight}">
    <router-view style="width: 100%" class="router-body" v-if="($route.name == 'login' ? true : false) || ($route.name == 'reviewer' ? true : false)"/>

    <div class="panel" v-if="($route.name == 'login' ? false : true) && ($route.name == 'reviewer' ? false : true)">
      <el-container>
        <navigation-view />
        <el-container direction="vertical" class="content" :style="{height:bodyHeight}">
          <header-view style="width: 100%" @resetPwd="resetPwd" :path="$route.path" />
          <keep-alive include="Paper,PaperCochair,PapeOperate,PaperSet,Email,Session,Topic,Cochair,User">
            <router-view style="width: 100%" class="router-body" />
          </keep-alive>
        </el-container>
      </el-container>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Index',
  data () {
    return {
      bodyHeight: window.innerHeight + 'px'
    }
  },
  mounted() {
 	// 进入页面时监听游览器高度变化
	window.addEventListener('resize', this.getHeight)
},
watch: {
	browserHeight: {
		// 游览器高度变化时，动态设置高度
		handler(nv) {
			this.setHeight = nv - 400 > 300 ? JSON.stringify(nv - 400) : '300'
		}
	}
},
  methods: {
    getHeight() {
		// 获取浏览器高度
		this.bodyHeight = window.innerHeight + 'px'
	},
    resetPwd: function () {
      console.log('退出登录页')
      this.editPwdVisible = true
      this.pwdForm = {
        userId: this.user.userId,
        userEmail: this.user.userEmail,
        password: '',
        passwordConfirm: ''
      }
    }
  },
  beforeRouteLeave(to, from, next) {
	// 离开页面时取消监听
	window.removeEventListener('resize', this.getHeight)
	next()
}
}
</script>

<style>
.content{
  -ms-overflow-style:none;
  overflow: scroll;
}
.content::-webkit-scrollbar{
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/index.vue